import { Project } from "../types";

export const filterProjects = (
  projects: Project[],
  activeFilter: string,
  searchTerm: string
): Project[] => {
  return projects.filter((project) => {
    const matchesCategory =
      activeFilter === "all" ||
      activeFilter === "points" ||
      project.category
        .split(",")
        .map((c) => c.trim())
        .includes(activeFilter);

    const matchesPoints = activeFilter !== "points" || project.points === "Yes";

    const matchesSearch =
      !searchTerm ||
      project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.category.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesCategory && matchesPoints && matchesSearch;
  });
};
